/**
 * Cross-module domain constants: values two or more modules put on the wire, or
 * agree on. A value used by one module belongs at the top of that module's file
 * (or `src/modules/<name>/constants.ts` once a second file there needs it).
 *
 * Not here: design values (`src/theme/tokens.ts` + `_variables.less`),
 * predicates and patterns (`src/utils/`), and API enums owned by a single
 * hook's DTO (keep those beside the type, in `src/hooks/<domain>/`).
 *
 * Split into `src/constants/<topic>.ts` with deep imports — no barrel — once
 * this file passes ~150 lines or ~8 top-level exports.
 */

// ----- Issue domain -----

export const ISSUE_TYPES = {
  OPERATIONAL_RISK: 'RO', //TODO type must ne issue-operational, issue-security, issue-performance, risk, event, etc
  INFORMATION_SECURITY: 'SI',
  BUSINESS_CONTINUITY: 'BC',
  AUDIT: 'AU',
  COMPLIANCE: 'CN'
} as const;


// ----- Query / pagination defaults -----

export const STATUS_PARAMS = {
  PROPERTY_FIND: 'si.typeIncident', //TODO must be type
  PROPERTY_ORDER: 'si.sequence',
  DEFAULT_START: 0,
  DEFAULT_LIMIT: 25
} as const;


export const PAGINATION = {
  DEFAULT_PAGE_LIMIT: 25,
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 25,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100]
};

// API endpoint parameters
export const API_PARAMS = {
  IMPACT: {
    ISSUES_ENTITY: 'ISSUES',
    DEFAULT_LIMIT: 100
  },
  S3: {
    // Final key: ISSUES/<issueUid>/Monitoring/<monitoringUid>
    MONITORING_SUBMODULE: 'Monitoring'
  },
  OPTIONS: {
    ISSUE_VALUE_FIND: 'ISSUE'
  },
  SEARCH: {
    DEFAULT_OFFSET: 0,
    DEFAULT_LIMIT: 20
  },
  IS_ACTIVE: 'S',
  ZERO: 0,
  ROOT: 'root',
  EMPTY: '',
} as const;


export type IssueType = typeof ISSUE_TYPES[keyof typeof ISSUE_TYPES];

// ----- Layout -----
// TODO: design values — belongs in src/theme/tokens.ts. SIDEBAR_WIDTH (250) already
// contradicts tokens.layout.siderExpanded (200) and @sider-expanded (200px).
export const LAYOUT = {
  HEADER_HEIGHT: 56,
  SIDEBAR_WIDTH: 250,
  SIDEBAR_COLLAPSED_WIDTH: 60,
} as const;
